import React, {useState, useEffect} from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Avatar, Box, Grid } from '@mui/material';
import Button from '@mui/material/Button';

import { useSelector, useDispatch } from 'react-redux';
import { constants } from '../../util'
import { showLogin, showPasswordChange, setLanguage } from '../../store/slices/configSlice';
import { setAuthenticated } from '../../store/slices/userSlice';

import { enqueueSnackbar } from 'notistack';

import { useTranslation } from 'react-i18next';

// import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import LanguageIcon from '@mui/icons-material/Language';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';

import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import KeyIcon from '@mui/icons-material/Key';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import GroupIcon from '@mui/icons-material/Group';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import GradingIcon from '@mui/icons-material/Grading';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';

import { googleLogout } from '@react-oauth/google';
import { boolean } from 'yup';

import {PasswordChange} from '../../pages/passwordChange';


const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    transform: window.innerWidth < 500 ? 'translateX(-10px) translateY(20px)' : 'translateX(35px) translateY(80px)',
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '5px solid currentColor',
      content: '""',
      transform: window.innerWidth < 500 ? 'translateX(-10px) translateY(20px)' : 'translateX(35px) translateY(80px)',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(2.2)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(3.4)',
      opacity: 0,
    },
  },
}));

const Header = () => {
    let location = useLocation();
    const [isMainPage, setIsMainPage] = useState(true);
    const [openPasswordChange, setOpenPasswordChange] = useState(false);
    const [hideHeader, setHideHeader] = useState(false);

    

    //===============================================
    //Options button
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    
    const handleClick_Go = (page) => {
        switch(page){
            case "home": 
                navigate("/");
                break;
            case "aboutus": 
                navigate("/aboutus");
                break;
            case "faq": 
                navigate("/faq");
                break;
            case "getintouch": 
                navigate("/getintouch");
                break;
            
            case "homeAuth":
                navigate("/index");
                break;
            case "profile":
                navigate("/profile");
                break;
            case "songs":
                navigate("/songs");
                break;
            case "approvalSongs":
                navigate("/approvalsongs");
                break;
            case "users":
                navigate("/useradmin");
                break;
            case "reviews":
                navigate("/reviews");
                break;
            case "contactQuestions":
                navigate("/questions");
                break;
            case "userView":
                navigate("/userview");
                break;
            case "passwordChange":
                dispatch(showPasswordChange(true));
                break;
            case "signOut":
                dispatch(setAuthenticated(null))

                try{
                    const ventanaLogout = window.open(
                        'https://accounts.google.com/logout',
                        '_blank',
                        'width=10,height=10,top=-1000,left=-1000'
                    );

                    setTimeout(() => {
                        if (ventanaLogout && !ventanaLogout.closed) {
                            ventanaLogout.close();
                        }
                        navigate("/"); 
                    }, 800);
                }
                catch(e){
                    const iframe = document.createElement('iframe');
                    iframe.src = 'https://accounts.google.com/logout';
                    iframe.style.display = 'none';
                    document.body.appendChild(iframe);
                }
                
                break;
            case "shareYourMusic":
                dispatch(showLogin(true));
                break;
        }
    };
    //===============================================
    

    const navigate = useNavigate();
    const {deviceType, language} = useSelector( state => state.configuration);
    const {authenticated, userLogged, profilePhoto} = useSelector( state => state.userLogged);

    const [scrolled, setScrolled] = useState(false);

    const dispatch = useDispatch();
    
    //TRANSLATION
    const [t, i18n] = useTranslation("global");


    
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    useEffect(() => {
        setIsMainPage(
            location.pathname==='/' ||
            location.pathname==='/home' ||
            location.pathname==='/aboutus' ||
            location.pathname==='/faq' ||
            location.pathname==='/getintouch'
        );

        setHideHeader(location.pathname==='/termsofuse' 
                || location.pathname==='/privacypolicy'
                || location.pathname==='/enduserdata'
        );
    }, [location.pathname]);


    const handleClick_Navigate = (page) => {
        switch(page){
            case "home": 
                navigate("/");
                break;
            case "aboutus": 
                navigate("/aboutus");
                break;
            case "faq": 
                navigate("/faq");
                break;
            case "getintouch": 
                navigate("/getintouch");
                break;
        }
    }
    


    
    const handleClickLanguge = () => {
        i18n.changeLanguage((language === 'es' ? 'en' : 'es'));
        window.localStorage.setItem('dl-lang', (language === 'es' ? 'en' : 'es'));
        dispatch(setLanguage((language === 'es' ? 'en' : 'es')));
        
        enqueueSnackbar(
            language === 'es' ? 'Language was successfully changed' : 'El idioma cambió correctamente'
            , { 
                variant: 'success',
                persist: false
            });
        
        // getYoutubeVideo()
        //     .then(rsp => {
        //         if (rsp.code === '00'){
        //             dispatch(setYoutubeVideo(rsp.metadata));
        //         }
        //     })
    }



    return(
        <div style={{width: '100%', display: hideHeader ? 'none' : '' }}>
            {/* <button onClick={()=>console.log(userLogged)} style={{marginTop:'150px'}}>click press</button> */}
            <Grid container direction="row" size={12}
                sx={{
                    height: '100px',
                    width: '100%', 
                    margin: 0, 
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    position: 'fixed',
                    zIndex:'1000',
                    top:'0',
                    boxShadow: isMainPage ? 'inset 0 80px 30px -20px rgba(28, 27, 27, .8)' : 'none',
                    transition: isMainPage ? 'background 0.8s ease' : 'none',
                    background: scrolled
                        ? 'linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, .8), rgba(0, 0, 0, 0))'
                        : 'transparent', 
                    backgroundColor: !isMainPage ? '#000000' : 'transparent'
                }}
            >
                <Grid size={1}>&nbsp;</Grid>
                <Grid size={10} direction="row" sx={{
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between'
                }}>
                    <div style={{
                        width: '25%',
                        display: 'flex', 
                        alignItems: 'center'
                    }}>
                        {
                            !isMainPage ? 
                                <img src='/assets/img/logo/logomain.jpg' style={{width:'50%', minWidth:'80px', marginTop: '0px'}} />
                            :
                                <img src='/assets/img/logo/dluna-white-transparent.png' style={{width: '60%', minWidth:'80px', marginTop: '20px'}} />
                        }
                    </div>
                    {
                        authenticated
                        ? null
                        : 
                            <Box sx={{
                                width: '60%',
                                height:'fit-content',
                                // paddingRight:'5%',
                                alignSelf:'center',
                                marginRight:'50px',
                                paddingTop:'0',
                                display: {
                                    sxs:'none',
                                    xs:'none',
                                    sm:'flex',
                                    md:'flex',
                                    lg:'flex',
                                    xl:'flex',
                                },
                                justifyContent: 'flex-end',
                            }}>
                                <Button variant="text" sx={{ ...constants.styles.linkButton, color:(authenticated ? 'white' : 'white'), fontSize: '13px' }} onClick={()=>handleClick_Navigate("home")}>{t("header.menuStart")}</Button>
                                <Button variant="text" sx={{ ...constants.styles.linkButton, color:(authenticated ? 'white' : 'white'), fontSize: '13px' }} onClick={()=>handleClick_Navigate("aboutus")}>{t("header.menuWhoWeAre")}</Button>
                                <Button variant="text" sx={{ ...constants.styles.linkButton, color:(authenticated ? 'white' : 'white'), fontSize: '13px' }} onClick={()=>handleClick_Navigate("faq")}>{t("header.menuFAQ")}</Button>
                                <Button variant="text" sx={{ ...constants.styles.linkButton, color:(authenticated ? 'white' : 'white'), fontSize: '13px' }} onClick={()=>handleClick_Navigate("getintouch")}>{t("header.menuContact")}</Button>
                            </Box>
                    }
                    <Box  sx={{
                        display:'flex',
                        direction:'row',
                        justifyContent:'flex-end',
                        alignItems:'center',
                        // backgroundColor:'green',
                        // width: {
                        //     sxs:'75%',
                        //     xs:'75%',
                        //     sm:'25%',
                        //     md:'15%',
                        //     lg:'15%',
                        //     xl:'15%',
                        // },
                    }}>
                        {
                            authenticated === false 
                            ? 
                                <div>
                                    <Button variant="text" sx={{ ...constants.styles.specialButton, 
                                        width:'200px',
                                        // width:{
                                        //     sxs:'60%',
                                        //     xs:'60%',
                                        //     sm:'100%',
                                        //     md:'80%',
                                        //     lg:'80%',
                                        //     xl:'60%',
                                        // },
                                        display: {
                                            sxs:'none',
                                            xs:'none',
                                            sm:'block',
                                            md:'block',
                                            lg:'block',
                                            xl:'block',
                                        },
                                    }} onClick={()=>dispatch(showLogin(true))}>{t("header.btnLogin")}</Button>

                                    
                                    <IconButton
                                        onClick={handleClick}
                                        size="small"
                                        sx={{ 
                                            justifySelf:'flex-end',
                                            display: {
                                                sxs:'block',
                                                xs:'block',
                                                sm:'none',
                                                md:'none',
                                                lg:'none',
                                                xl:'none',
                                            },
                                        }}
                                        aria-controls={open ? 'account-menu' : undefined}
                                        aria-expanded={open ? 'true' : undefined}
                                        aria-haspopup="true"
                                    >
                                        <MenuIcon sx={{ width: 32, height: 32, color:'white' }}></MenuIcon>
                                    </IconButton>
                                </div>
                                
                            :
                                <div>
                                <Tooltip>
                                    <StyledBadge
                                        overlap="circular"
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                        variant="dot"
                                    >
                                        <IconButton
                                            onClick={(e)=>handleClick(e)}
                                            size="small"
                                            sx={{ 
                                                justifySelf:'flex-end',
                                                // display: {
                                                //     sxs:'block',
                                                //     xs:'block',
                                                //     sm:'none',
                                                //     md:'none',
                                                //     lg:'none',
                                                //     xl:'none',
                                                // },
                                            }}
                                            aria-controls={open ? 'account-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                        >
                                        
                                            <Avatar src={profilePhoto} 
                                                sx={{ 
                                                    backgroundColor: '#dfdfdf',
                                                    width:{
                                                        sxs:'50px',
                                                        xs:'50px',
                                                        sm:'100px',
                                                        md:'100px',
                                                        lg:'100px',
                                                        xl:'100px',
                                                    }, 
                                                    height:{
                                                        sxs:'50px',
                                                        xs:'50px',
                                                        sm:'100px',
                                                        md:'100px',
                                                        lg:'100px',
                                                        xl:'100px',
                                                    }, 
                                                    position:'absolute', 
                                                    // top:'14%', 
                                                    border:'2px solid #FFFFFF',
                                                    transform:{
                                                        sxs:'translateX(-30px) translateY(0px)',
                                                        xs:'translateX(-30px) translateY(0px)',
                                                        sm:'translateX(0px) translateY(40px)',
                                                        md:'translateX(0px) translateY(40px)',
                                                        lg:'translateX(0px) translateY(40px)',
                                                        xl:'translateX(0px) translateY(40px)',
                                                    },
                                                }}
                                            />
                                        </IconButton>
                                    </StyledBadge>
                                </Tooltip>

                                
                                </div>
                        }
                        <Button variant="text" //startIcon={<LanguageIcon />} 
                            onClick={()=>handleClickLanguge()}
                            sx={{
                                textTransform:'none', 
                                marginLeft: authenticated ? '50px' : '10px', 
                                color:'#ffffff', 
                                backgroundColor:'transparent',
                                border:'0px',
                                display: {
                                            sxs:'none',
                                            xs:'none',
                                            sm:'flex',
                                            md:'flex',
                                            lg:'flex',
                                            xl:'flex',
                                        },
                            }}>
                                <img src={language=='en' ? "/assets/img/flags/mx.svg" : "/assets/img/flags/us.svg" } style={{width:'35px', height:'35px'}} />
                            {t("footer.btnLanguage")}
                        </Button>
                
                        <Menu 
                            sx={{
                                transform:{
                                    sxs:'translateX(0px) translateY(20px)',
                                    xs:'translateX(0px) translateY(20px)',
                                    sm:'translateX(45px) translateY(85px)',
                                    md:'translateX(45px) translateY(85px)',
                                    lg:'translateX(45px) translateY(85px)',
                                    xl:'translateX(45px) translateY(85px)',
                                },
                                
                                // display: {
                                //     sxs:'block',
                                //     xs:'block',
                                //     sm:'none',
                                //     md:'none',
                                //     lg:'none',
                                //     xl:'none',
                                // },
                            }}
                            anchorEl={anchorEl}
                            id="account-menu"
                            open={open}
                            onClose={handleClose}
                            onClick={handleClose}
                            slotProps={{
                                paper: {
                                    elevation: 0,
                                    sx: {
                                        overflow: 'visible',
                                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                        mt: 1.5,
                                        '& .MuiAvatar-root': {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                        },
                                        '&::before': {
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: 'background.paper',
                                            transform: 'translateY(-50%) rotate(45deg)',
                                            zIndex: 0,
                                        },
                                    },
                                },
                            }}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                        >
                            {
                                authenticated
                                ? 
                                    <div style={{width:'100%'}}>
                                        <Typography sx={{fontWeight:'bold', marginLeft:'15px', marginRight:'15px'}}>
                                            &nbsp;
                                        </Typography>
                                        <Typography sx={{fontSize:'16px', fontWeight:'bold', textAlign:'center', marginLeft:'15px', marginRight:'15px'}}>
                                            {userLogged.name}
                                        </Typography>
                                        <Typography sx={{fontSize:'10px', textAlign:'center', marginLeft:'15px', marginRight:'15px'}}>
                                            {userLogged.email}
                                        </Typography>
                                        <Typography sx={{fontSize:'10px', textAlign:'center', marginLeft:'15px', marginRight:'15px'}}>
                                            {
                                                language==='en' && userLogged.role==='Administrador' ? 'Administrator'
                                                : language==='en' && userLogged.role==='Aprobador' ? 'Reviewer'
                                                : language==='en' && userLogged.role==='Artista' ? 'Artist'
                                                : userLogged.role
                                                
                                            }
                                        </Typography>
                                        <Typography sx={{fontSize:'10px', textAlign:'center', marginLeft:'15px', marginRight:'15px'}}>
                                            &nbsp;
                                        </Typography>
                                        <MenuItem onClick={()=>handleClick_Go("homeAuth")}>
                                            <HomeIcon sx={{marginRight:'15px'}} />
                                            {t("menu.homeAuth")}
                                        </MenuItem>
                                        <MenuItem onClick={()=>handleClick_Go("songs")}
                                            sx={{display: userLogged.role==='Artista' ? '' : 'none'}}
                                        >
                                            <QueueMusicIcon sx={{marginRight:'15px'}} />
                                            {t("menu.songs")}
                                        </MenuItem>
                                        <MenuItem onClick={()=>handleClick_Go("approvalSongs")}
                                            sx={{display: userLogged.role==='Artista' ? 'none' : ''}}
                                        >
                                            <QueueMusicIcon sx={{marginRight:'15px'}} />
                                            {t("menu.approvalSongs")}
                                        </MenuItem>
                                        <MenuItem onClick={()=>handleClick_Go("reviews")}
                                            sx={{display: userLogged.role==='Artista' ? 'none' : (userLogged.role==='Aprobador' ? 'none' : '')}}
                                        >
                                            <GradingIcon sx={{marginRight:'15px'}} />
                                            {t("menu.reviews")}
                                        </MenuItem>
                                        <Divider sx={{boxShadow:'0px 1px #E5E7E9', width:'90%', justifySelf:'center',
                                            display: userLogged.role==='Artista' ? 'none' : ''
                                        }}/>
                                        <MenuItem onClick={()=>handleClick_Go("contactQuestions")}
                                            sx={{display: userLogged.role==='Artista' ? 'none' : ''}}
                                        >
                                            <QuestionMarkIcon sx={{marginRight:'15px'}} />
                                            {t("menu.contactQuestions")}
                                        </MenuItem>
                                        <MenuItem onClick={()=>handleClick_Go("userView")}
                                            sx={{display: userLogged.role==='Artista' ? 'none' : ''}}
                                        >
                                            <SupervisedUserCircleIcon sx={{marginRight:'15px'}} />
                                            {t("menu.userView")}
                                        </MenuItem>
                                        <MenuItem onClick={()=>handleClick_Go("users")}
                                            sx={{display: userLogged.role==='Artista' ? 'none' : (userLogged.role==='Aprobador' ? 'none' : '')}}
                                        >
                                            <GroupIcon sx={{marginRight:'15px'}} />
                                            {t("menu.users")}
                                        </MenuItem>
                                        <Divider sx={{boxShadow:'0px 1px #E5E7E9', width:'90%', justifySelf:'center',
                                            
                                        }}/>
                                        <MenuItem onClick={()=>handleClick_Go("profile")}
                                            sx={{display: userLogged.role==='Artista' ? '' : 'none'}}
                                        >
                                            <AccountBoxIcon sx={{marginRight:'15px'}} />
                                            {t("menu.profile")}
                                        </MenuItem>
                                        <MenuItem 
                                            onClick={()=>handleClick_Go("passwordChange")}
                                            disabled={userLogged.googleAuthenticated}
                                        >
                                            <KeyIcon sx={{marginRight:'15px'}} />
                                            {t("menu.passwordChange")}
                                        </MenuItem>
                                        <Divider sx={{boxShadow:'0px 1px #E5E7E9', width:'90%', justifySelf:'center'}}/>
                                        <MenuItem onClick={()=>handleClick_Go("signOut")}>
                                            <ExitToAppIcon sx={{marginRight:'15px'}} />
                                            {t("menu.signOut")}
                                        </MenuItem>
                                    </div>
                                :
                                    <div>
                                        <MenuItem onClick={()=>handleClick_Go("home")}>
                                            {t("header.menuStart")}
                                        </MenuItem>
                                        <MenuItem onClick={()=>handleClick_Go("aboutus")}>
                                            {t("header.menuWhoWeAre")}
                                        </MenuItem>
                                        <MenuItem onClick={()=>handleClick_Go("faq")}>
                                            {t("header.menuFAQ")}
                                        </MenuItem>
                                        <MenuItem onClick={()=>handleClick_Go("getintouch")}>
                                            {t("header.menuContact")}
                                        </MenuItem>
                                        <MenuItem onClick={()=>handleClick_Go("shareYourMusic")}
                                            sx={{...constants.styles.mainButton, width:'90%', justifySelf:'center', justifyContent:'center'}}
                                        >
                                            {t("header.btnLogin")}
                                        </MenuItem>
                                    </div>
                            }
                            
                        </Menu>
                    </Box>
                </Grid>
                <Grid size={1}>&nbsp;</Grid>
            </Grid>
        </div>
    );
}

export default Header;